<template lang="pug">
div
	h1 Échte wintersportdekking
	insurance-info-block

	v-row
		v-col
			v-card.flex.d-flex.flex-column(outlined height="100%")
				v-card-text.text-center.flex.pb-0
					v-img.mb-3(src="https://static.wintersport.nl/images/nskiv/insurance_case_1.jpg" :aspect-ratio="16/9")
				v-card-text.text-center.pt-0
					v-btn.disable-events.mb-2(outlined depressed block color="primary" nuxt :to="localePath({ name: 'verzekering-reisverzekering'})") kies je verzekering
		v-col
			v-card.flex.d-flex.flex-column(outlined height="100%")
				v-card-text.text-center.flex.pb-0
					v-img.mb-3(src="https://static.wintersport.nl/images/nskiv/insurance_case_2.jpg" :aspect-ratio="16/9")
				v-card-text.text-center.pt-0
					v-btn.disable-events.mb-2(outlined depressed block color="primary" nuxt :to="localePath({ name: 'verzekering-profiel'})") schade melden
		v-col
			v-card.flex.d-flex.flex-column(outlined height="100%")
				v-card-text.text-center.flex.pb-0
					v-img.mb-3(src="https://static.wintersport.nl/images/nskiv/insurance_case_3.jpg" :aspect-ratio="16/9")
				v-card-text.mt-0.text-center.pt-0
					v-btn.disable-events.mb-2(outlined depressed block color="primary" :to="localePath({ name: 'verzekering-profiel'})") mijn verzekering
</template>

<script>
import insuranceInfoBlock from '@/components/insurance-info-block.vue';

export default {
	name: 'Insurance',
	nuxtI18n: {
		paths: {
			'nl-NL': '/verzekering'
		}
	},
	components: {
		insuranceInfoBlock
	},
	layout: 'default',
	scrollToTop: true,
	asyncData({ app }) {
		app.ads({});
		app.meta({
			title:
				'Dé reisverzekering voor wintersporters - Nederlandse Ski Vereniging',
			description:
				'Autopech op weg naar de wintersport, knie verdraaid bij het uitstappen uit de stoeltjeslift, een steen geraakt die verscholen lag onder de poedersneeuw.',
			hasFollow: true,
			hasIndex: true
		});
		app.breadcrumbs({
			[app.i18n.t('page.insurance:breadcrumb')]: { name: 'verzekering' }
		});
	},
	head() {
		return {
			...this.$structuredData()
		};
	}
};
</script>
